import { useEffect } from 'react'
import { getEnv } from '@/lib/env'

type PageTitleProps = {
  title: string
}

/**
 * Sets the document title for the current page.
 * Usage: <PageTitle title="Dashboard" /> → "Dashboard — Medconnect Patient"
 * Fixes RGAA 8.6: unique page titles.
 */
export function PageTitle({ title }: PageTitleProps) {
  const siteName = getEnv('NEXT_PUBLIC_META_TITLE', 'Medconnect Patient')

  useEffect(() => {
    document.title = title ? `${title} — ${siteName}` : siteName
    return () => {
      document.title = siteName
    }
  }, [title, siteName])

  return null
}
